import { render, staticRenderFns } from "./itemwrapper.vue?vue&type=template&id=c4fe7250"
import script from "./itemwrapper.ts?vue&type=script&lang=js&external"
export * from "./itemwrapper.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4fe7250')) {
      api.createRecord('c4fe7250', component.options)
    } else {
      api.reload('c4fe7250', component.options)
    }
    module.hot.accept("./itemwrapper.vue?vue&type=template&id=c4fe7250", function () {
      api.rerender('c4fe7250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/itemwrapper.vue"
export default component.exports